import { FC } from "react";
import Alerts, { alertsProps } from "./Alerts";
import Input, { inputProps } from "./Input";
import Toasts, { toastsProps } from "./Toasts";
import SAlert from "./SweetAlert";
import { SweetAlertOptionalProps } from "./SweetAlert/SweetAlert";

export const BTAlerts: FC<alertsProps> = (props) => <Alerts {...props} />;
export const BTInput: FC<inputProps> = (props) => <Input {...props} />;
export const BTToasts: FC<toastsProps> = (props) => <Toasts {...props} />;
export const SweetAlert: FC<SweetAlertOptionalProps> = (props) => <SAlert {...props} />;